import { CatalogOtherCostVariableTypeEnum } from 'gql/graphql';

import type { CatalogVariablesOtherRow } from './types';

export const getVariableSourceLabel = (row?: CatalogVariablesOtherRow | null): string => {
    if (!row) {
        return '';
    }

    if (row.type === CatalogOtherCostVariableTypeEnum.Simple) {
        return row.dataSourceName ?? '';
    }

    if (row.type === CatalogOtherCostVariableTypeEnum.Composite) {
        return row.formula ?? '';
    }

    return row.otherCostType?.name ?? row.limitedCostType?.name ?? '';
};
